import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/error.png';
const _withScopeId = n => (_pushScopeId("data-v-674ed1d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
export default {
  __name: 'swipers',
  props: {
    swiperImg: {
      type: Array,
      default: []
    }
  },
  setup(__props) {
    const props = __props;

    // let swiperImg = ref([
    //     {cover:'https://picsum.photos/360/460?radom='+Math.ceil(Math.random()*100),url:'www.baidu.com'},
    //     {cover:'https://picsum.photos/360/460?radom='+Math.ceil(Math.random()*100),url:'www.baidu.com'},
    //     {cover:'https://picsum.photos/360/460?radom='+Math.ceil(Math.random()*100),url:'www.baidu.com'},
    //     {cover:'https://picsum.photos/360/460?radom='+Math.ceil(Math.random()*100),url:'www.baidu.com'},
    //     {cover:'https://picsum.photos/360/460?radom='+Math.ceil(Math.random()*100),url:'www.baidu.com'},
    // ])
    // 在modules加入要使用的模块

    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      return _openBlock(), _createBlock(_component_van_swipe, {
        class: "my-swipe",
        autoplay: 3000,
        "indicator-color": "white"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.swiperImg, (item, index) => {
          return _openBlock(), _createBlock(_component_van_swipe_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              href: item.ad_url
            }, [_createVNode(_component_van_image, {
              src: item.ad_image
            }, {
              error: _withCtx(() => [_hoisted_2]),
              _: 2
            }, 1032, ["src"])], 8, _hoisted_1)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      });
    };
  }
};